import React, { useState, useEffect } from 'react';
import './navbar.css';
//import { useLocation } from "react-router-dom";
import axios from "axios";
//import DatePicker from "react-datepicker";
import {  Row, Col } from 'react-bootstrap';



const Tutor_Form_Base = (props) => {

    const [variab_aggiorna, SET_variab_aggiorna] = useState('');
    const [end_Date, set_End_Date] = useState(new Date());
    const [input, setInput] = useState({
        nome: '',
        cognome: '',
        luogo_nascita: '',
        email: '',
        email_genitore: '',
        classe: '',
        corso: ''
    });


    useEffect(() => {
        console.log('USEEFFECT alunno_form_base')
        console.log(props.id)

        axios.get('/tutor/trova_tutor/' + props.id)
            .then((res) => {
                console.log('domande appena fecciate da mongo')
                //                console.log(res.data)
                setInput(res.data)
                console.log(res.data.data_nascita)
                //                var dateObj = new Date(res.data.data_nascita);
                //                set_End_Date(dateObj)

            }).catch((error) => {
                console.log(error)
            });
    }, [props.id]);



    function handleChange(event) {
        const { name, value } = event.target;
        console.log('sssssss')

        console.log(end_Date)
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }


    function handleClick(event) {
        event.preventDefault();
   
        axios.patch('/tutor/tutor_modifica/' + props.id, input)
            .then((res) => {
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
        props.setShow(false)
        //            variab_aggiorna = {variab_aggiorna} SET_variab_aggiorna={SET_variab_aggiorna}
    }

    return (
        <div>
            <div className='container'>
                <h2>Form Alunno</h2>
                <form>
                    <div className='form-group'>
                        <p>

                            <span class="border border-primary">
                                <Row>
                                    <Col>
                                        <label>Cognome</label>
                                        <input onChange={handleChange} placeholder="Cognome" name="cognome" value={input.cognome} autoComplete="off" className="form-control"></input>
                                    </Col>
                                    <Col> 
                                        <label>Nome</label>
                                        <input onChange={handleChange} placeholder="Nome" name="nome" value={input.nome} autoComplete="off" className="form-control"></input>
                                    </Col>
                                </Row>
                            </span>
                        </p>
                        <p>
                            <Row>
                                <Col>
                                    <label>Cellulare</label>
                                    <input onChange={handleChange} placeholder="Cellulare" name="cellulare" value={input.cellulare} autoComplete="off" className="form-control"></input>
                                </Col>
                                <Col>
                                    <label>Email</label>
                                    <input onChange={handleChange} placeholder="e-mail" name="email" value={input.email} autoComplete="off" className="form-control"></input>
                                </Col>


                            </Row>
                        </p>
                  
                  
                    </div>

                    <button onClick={handleClick} className="btn btn-lg btn-info">Salva</button>

                </form>
            </div>
        </div>
    );
}
export default Tutor_Form_Base;